"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUIDropdownSection = function AUIDropdownSection(_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        "div",
        { className: "aui-dropdown2-section" },
        _react2.default.createElement(
            "ul",
            { className: "aui-list-truncate" },
            children
        )
    );
};

AUIDropdownSection.displayName = "AUIDropdownSection";
exports.default = AUIDropdownSection;
//# sourceMappingURL=AUIDropdownSection.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIDropdownSection.js
// module id = 183
// module chunks = 0